import Modal from "@src/components/UIElements/Modal";
import { t } from "i18next";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { useDispatch, useSelector } from "react-redux";
import { showApplyBundleBottomSheetAction } from "../../store/actions";
import { Image } from "@src/components/Image";
import { useTranslation } from "react-i18next";
import book from "@src/components/BottomSheets/components/ApplyBundleBottomSheet/Images/Book.png";

const ApplyBundleBottomSheet = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showApplyCouponBottomSheet
  );
  const bundleData = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(showApplyBundleBottomSheetAction(false));
      }}
      header={
        <div className="couponModalHeader">
          {/* <Image
            src={getAwsAssets("CouponList.svg", "Overview")}
            className="SVGCoupons"
            height="20px"
            width="20px"
            alt={t(
              "components.bottomSheets.components.applyCouponBottomSheet.couponlist",
              "couponlist"
            )}
          /> */}
          <span className="couponModalHeader--title">
            {t(
              "components.bottomSheets.components.applyBottomSheet.modalBunleHeaderText",
              "Included in this bundle"
            )}
          </span>
        </div>
      }
    >
      {bundleData?.map((item, index) => {
        return (
          <div className="bundleListItem" key={index}>
            <div className="img-div">
              <Image
                src={
                  item?.courseType == "BOOKS"
                    ? getAwsAssets("Book20062023.png", "Overview")
                    : getAwsAssets("testBook20062023.png", "Overview")
                }
                height="40px"
                width="40px"
                alt={t(
                  "components.bottomSheets.components.applyBundleBottomSheet.couponlist",
                  "Bundlelist"
                )}
              />
            </div>
            <div className="content-div">
              <p>{item?.courseName}</p>
            </div>
          </div>
        );
      })}
    </Modal>
  );
};
export default ApplyBundleBottomSheet;
